import React from 'react';
import GifItem from './GifItem';

  const GifList = (props) => {  
  const gifItems = props.gifs.map((image) => {
// setTimeout(() => {
    return (
                <GifItem key={image.id}
                    gif={image}
                    onGifSelect={props.onGifSelect}
                    onFavoriteSelect={props.onFavoriteSelect}
                    onFavoriteDeselect={props.onFavoriteDeselect}
                    isAuthenticated={props.isAuthenticated}
                    isFavorite={props.isFavorite} />
          )
// }, 3000)
  });

  return (
      <div className="gif-list">{gifItems}</div>
  );
}

export default GifList;


// WEBPACK FOOTER //
// ./src/components/GifList.js